import type { RoomView } from "../server/types";

export class RequestError extends Error {
  constructor(
    message: string,
    public status: number,
    public code: string,
    public room?: RoomView,
  ) {
    super(message);
  }
}
export async function api<T>(path: string, body?: unknown): Promise<T> {
  const response = await fetch(path, {
    method: body === undefined ? "GET" : "POST",
    headers:
      body === undefined ? undefined : { "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
    credentials: "same-origin",
    cache: "no-store",
  });
  const data = (await response.json().catch(() => null)) as {
    error?: { code?: string; message?: string };
    room?: RoomView;
  } | null;
  if (!response.ok)
    throw new RequestError(
      data?.error?.message ??
        "The connection was interrupted. Please try again.",
      response.status,
      data?.error?.code ?? "request_failed",
      data?.room,
    );
  return data as T;
}
export function rememberRoom(id: string) {
  try {
    const existing = JSON.parse(
      localStorage.getItem("europe.rooms") ?? "[]",
    ) as string[];
    localStorage.setItem(
      "europe.rooms",
      JSON.stringify([id, ...existing.filter((x) => x !== id)].slice(0, 6)),
    );
  } catch {
    /* Private browsing may not allow storage. */
  }
}
export function recentRooms(): string[] {
  try {
    return JSON.parse(localStorage.getItem("europe.rooms") ?? "[]");
  } catch {
    return [];
  }
}
